// extracted by mini-css-extract-plugin
export default {"detailsContainer":"styles_detailsContainer__hutxL","details":"styles_details__21-7b","ticketAndDescription":"styles_ticketAndDescription__iWz2t","image":"styles_image__bgihb"};